import { Injectable } from '@angular/core';
import { StorageService } from '@web-frontend/shared/services';

import { ToastService } from '@web-frontend/shared/services/toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class ProFeatureService {
  constructor(private toastService: ToastService) {}

  openUser(erroText: string) {
    this.toastService.show({
      text: erroText,
      type: 'error',
      msDuration: 5000,
    });
  }

  get userLanguage(): string {
    return StorageService.GetItem('USER_LANG');
  }
}
